<template>
  <div class="outBox">
    <div class="box">
      <div v-loading="loading" element-loading-text="加载数据中"
           element-loading-spinner="el-icon-loading"
           element-loading-background="rgba(0, 0, 0, 0.2)"
           class="mine"></div>
      <div id="main2" class="chart-container"></div>
    </div>
  </div>

</template>

<script>
import * as echarts from 'echarts';

const DEVICE_TYPE_MAP = {
  '1': '771/772',
  '2': '775',
  '3': '776',
  '4': '779',
  '5': '780',
  '6': '781',
  '7': '782',
  '8': '783',
}

export default {
  name: "echartsTwo",
  data(){
    return {
      chart: null,
      loading: false, // 控制加载效果的显示与隐藏
    }
  },
  props: ['dataTwo','category'],
  mounted() {

// 基于准备好的dom，初始化echarts实例
    this.chart = echarts.init(document.getElementById('main2'));
    this.initBar();
    const _this = this;
    this.$nextTick(function () {
      this.$on('resizeTwo', function () {
        _this.chart.resize();
      })
    });
  },
  methods:{
    formatDecimal(value) {
      const num = Number(value)
      if (Number.isNaN(num)) return '0.00'
      return num.toFixed(2)
    },
    initBar(){
      if (!this.chart) return

      this.loading = true;

      let option = {
        backgroundColor: 'transparent',
        color: [
          '#00d4ff',
          '#8b5cf6',
          '#06b6d4',
          '#ec4899',
          '#22c55e',
          '#f59e0b',
          '#ef4444',
          '#3b82f6'
        ],
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(15, 23, 42, 0.9)',
          borderColor: 'rgba(0, 212, 255, 0.5)',
          borderWidth: 1,
          textStyle: {
            color: '#e5f4ff',
            fontSize: 12
          },
          formatter: (params) => {
            const value = this.formatDecimal(params.value)
            const percent = this.formatDecimal(params.percent)
            return `${params.marker}${params.name}<br/>${value} (${percent}%)`
          }
        },
        legend: {
          top: '5%',
          left: 'center',
          textStyle: {
            color: '#e5f4ff',
            fontSize: 12,
            fontWeight: 'normal'
          },
          itemWidth: 10,
          itemHeight: 10
        },
        series: [
          {
            name: '销售额',
            type: 'pie',
            radius: ['30%', '55%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 8,
              borderColor: 'rgba(15,23,42,0.9)',
              borderWidth: 1
            },
            label: {
              show: false,
              position: 'center',
              color: '#fff',
              formatter: (params) => {
                const value = this.formatDecimal(params.value)
                const percent = this.formatDecimal(params.percent)
                return `${params.name}\n${value}\n${percent}%`
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 12,
                fontWeight: 'bold',
                formatter: (params) => {
                  const value = this.formatDecimal(params.value)
                  const percent = this.formatDecimal(params.percent)
                  return `${params.name}\n${value}\n${percent}%`
                }
              }
            },
            labelLine: {
              show: false
            },
            data: this.filterBarData(),
            minAngle: 30 // 这里设置最小角度
          }
        ]
      };

      // 使用刚指定的配置项和数据显示图表。
      this.chart.setOption(option);
      this.loading = false;
    },
    filterBarData(){
      // 筛选仪表盘的数据
      if (!this.dataTwo || !Array.isArray(this.dataTwo)) {
        return []
      }

      const dataMap = new Map()
      this.dataTwo.forEach((item) => {
        if (item && item.name != null) {
          dataMap.set(String(item.name), item)
        }
      })

      const categories = Array.isArray(this.category) && this.category.length
        ? this.category
        : Object.keys(DEVICE_TYPE_MAP)

      const filterdData = []
      categories.forEach((cat) => {
        const name = DEVICE_TYPE_MAP[String(cat)]
        if (!name) return
        const item = dataMap.get(name)
        if (item) {
          filterdData.push({
            ...item,
            value: Number(item.value) || 0
          })
        }
      })
      return filterdData
    }
  },
  watch: {
    dataTwo(){
      this.initBar()
    },
    category: {
      deep: true,
      handler() {
        this.initBar()
      }
    }
  },
  beforeDestroy() {
    // 使用 dispose() 并做好空值判断，避免 beforeDestroy 阶段 this.chart 为空时报错
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  }
}
</script>

<style scoped>
.outBox {
  width: 100%;
  height: 220px;
}

.box {
  width: 100%;
  height: 220px; /* 与组件中的高度一致 */
  position: relative;
}

.mine {
  width: 100%;
  height: 100%; /* 与组件中的高度一致 */
  position: absolute;
  top: 0;
  left: 0;
}

.chart-container {
  width: 100%;
  height: 100%; /* 与组件中的高度一致 */
}


</style>
